import React from 'react';

const IconPytorch = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48px" height="48px">
    <path
      fill="#EE4C2C"
      d="M24 8c-1.2 0-2.3.2-3.3.6L14 18.5v11L24 40l10-10.5v-11L27.3 8.6C26.3 8.2 25.2 8 24 8zm0 4c.6 0 1.2.1 1.7.3l6 5.2v7.8l-6 6.3-6-6.3v-7.8l6-5.2c.5-.2 1.1-.3 1.7-.3z"
    />
    <path
      fill="#FF6F00"
      d="M24 14l-6 5.2v7.8l6 6.3 6-6.3v-7.8L24 14zm0 4.5l2.5 2.2v4.6L24 27.5l-2.5-2.2v-4.6L24 18.5z"
    />
  </svg>
);

export default IconPytorch;
